var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",class:_vm.type,style:(_vm.markerStyle),on:{"mouseenter":function($event){return _vm.$emit('enter');},"mouseleave":function($event){return _vm.$emit('leave');}}})}
var staticRenderFns = []

export { render, staticRenderFns }